module.exports = __webpack_public_path__ + "static/media/SacredHeartSchoolWeymouth.305c0572.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/main/SacredHeartSchoolWeymouth.jpg
// module id = 755
// module chunks = 0